import { IConfigCache, IConfigCacheName } from '../interface/config';

const settings: IConfigCache = {
    [IConfigCacheName.PublicAssets]: {
        cacheName: 'app-public-cache',
        expiration: 21 * 24 * 60 * 60,
        maxEntries: 200,
        matcher: /public\/*/,
    },
    [IConfigCacheName.BuildAssets]: {
        cacheName: 'app-build-cache',
        expiration: 21 * 24 * 60 * 60,
        maxEntries: 200,
        matcher: /static\/*/,
    },
    [IConfigCacheName.WorkspaceMedia]: {
        cacheName: 'app-media-cache',
        expiration: 21 * 24 * 60 * 60,
        maxEntries: 1000,
        matcher: /app.GetFile/,
    },
    [IConfigCacheName.AppToken]: {
        tokenPath: '/apptoken',
    },
};

export default settings;
